import { initCommonIcons, initProsIcons, initBenefitsIcon, initHeroIcons, initMediaIcons, initHumanResourcesIcons, initDentistIcons } from "./modules/init-icons";
import initSwiper from "./modules/init-swiper";
import Form from "./modules/form";

initHumanResourcesIcons();
initHeroIcons();
initCommonIcons();
initProsIcons();
initBenefitsIcon();
initHumanResourcesIcons();
initMediaIcons();
initDentistIcons();
initSwiper();

const form = new Form(".form");
